import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/GetEnergyPrice'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class GetEnergyPriceStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "GetEnergyPriceStore",
			variables: false,
		})
	}
}

export async function load_GetEnergyPrice(params) {
  await initClient()

	const store = new GetEnergyPriceStore()

	await store.fetch(params)

	return {
		GetEnergyPrice: store,
	}
}
